import React from 'react';
import { Box } from '@chakra-ui/react';

const BannerArea = () => {
  return (
    <Box
      // position="absolute"
      width="100%"
      display="flex"
      justifyContent="center"
      pt={12}
      pl={4}
    >
      <Box
        bg="white"
        color="black"
        p={3}
        borderRadius="md"
        boxShadow="md"
        fontSize="sm"
        maxW="320px"
        textAlign="center"
      >
        <a
          href="//af.moshimo.com/af/c/click?a_id=5106278&p_id=2011&pc_id=4076&pl_id=27526"
          rel="noopener noreferrer"
          referrerPolicy="no-referrer-when-downgrade"
          target="_blank"
        >
          <img
            src="//image.moshimo.com/af-img/1388/000000027526.png"
            width="320"
            height="100"
            style={{ border: 'none' }}
          />
        </a>
        <img
          src="//i.moshimo.com/af/i/impression?a_id=5106278&p_id=2011&pc_id=4076&pl_id=27526"
          width="1"
          height="1"
          style={{ border: 'none' }}
          loading="lazy"
        />
      </Box>
    </Box>
  );
};
export default BannerArea;
